import { useEffect, useState } from "react";
import { api, ApiError } from "../api";
import { Notice } from "../components";
import { useSession } from "../session";
import { Link } from "../router";
import { inr } from "../money";

const FLAG: Record<string, string> = { trial_ending: "Trial ends in 3 days", payment_overdue: "Payment overdue", inactive_7d: "No activity for 7 days", not_onboarded: "Only one user after 3 days" };

/** SaaS operator view: tenants and aggregate usage. No patient data is available here by design. */
export function PlatformConsole() {
  const { me, signOut } = useSession();
  const [d, setD] = useState<any>(null), [err, setErr] = useState<string | null>(null);
  useEffect(() => { api.authed("/api/platform/v1/tenants").then(setD).catch((e: ApiError) => setErr(e.message)); }, []);
  return (
    <div className="platform">
      <header className="platform-head"><strong>HealthOS platform console</strong><span>{me?.user.fullName} · <button className="link-button" onClick={signOut}>Sign out</button></span></header>
      <main className="platform-main">
        <h1>Hospitals and clinics</h1>
        <p className="muted">Counts and totals only. Patient and clinical records are never shown here.</p>
        {err && <Notice tone="error">{err}</Notice>}
        {!d && !err && <p className="muted" role="status">Loading tenants…</p>}
        {d && <>
          <div className="stats">
            <div className="stat"><span className="stat-value">{d.totals.tenants}</span><span className="stat-label">Tenants</span></div>
            <div className="stat"><span className="stat-value">{d.totals.active}</span><span className="stat-label">Paying</span></div>
            <div className="stat"><span className="stat-value">{d.totals.trial}</span><span className="stat-label">On trial</span></div>
            <div className="stat"><span className="stat-value">{d.totals.appointments30d}</span><span className="stat-label">Appointments (30 days)</span></div>
            <div className="stat"><span className="stat-value">{inr(d.totals.collected30d)}</span><span className="stat-label">Collected by tenants (30 days)</span></div>
          </div>
          <table className="data"><thead><tr><th scope="col">Tenant</th><th scope="col">Plan</th><th scope="col">Status</th><th scope="col" className="num">Users</th><th scope="col" className="num">Patients</th>
            <th scope="col" className="num">Appts 30d</th><th scope="col" className="num">Online 30d</th><th scope="col" className="num">Collected 30d</th><th scope="col">Last activity</th><th scope="col">Attention</th></tr></thead>
            <tbody>{d.tenants.map((t: any) => <tr key={t.tenantId}><td>{t.name}</td><td>{t.plan}</td><td>{t.status}</td><td className="num">{t.activeUsers}</td><td className="num">{t.patients}</td>
              <td className="num">{t.appointments30d}</td><td className="num">{t.onlineBookings30d}</td><td className="num">{inr(t.collected30d)}</td>
              <td className="small">{t.lastActivityAt ? new Date(t.lastActivityAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—"}</td>
              <td>{t.flags.map((f: string) => <span key={f} className="prio">{FLAG[f] ?? f}</span>)}</td></tr>)}</tbody></table>
        </>}
        {me && me.memberships.length > 0 && <p><Link to="/select-organisation">Go to a hospital</Link></p>}
      </main>
    </div>
  );
}
